import {EyebrowText, SectionIntro} from '@primer/react-brand'
import type {Document} from '@contentful/rich-text-types'

import {renderWithNoMarks} from '../../../utils'

type PricingSectionIntroProps = {
  label?: string
  heading?: Document
  description?: Document
}

export function PricingSectionIntro({label, heading, description}: PricingSectionIntroProps) {
  return (
    <SectionIntro align="center">
      {label && (
        <EyebrowText>
          <span style={{display: 'inline-flex', alignItems: 'center', gap: '0.25em'}}>
            {label}
            <span
              aria-hidden="true"
              style={{
                width: 'var(--base-size-8)',
                height: '1cap',
                backgroundColor: 'var(--brand-color-success-fg)',
              }}
            />
          </span>
        </EyebrowText>
      )}
      {heading && <SectionIntro.Heading>{renderWithNoMarks(heading)}</SectionIntro.Heading>}
      {description && <SectionIntro.Description>{renderWithNoMarks(description)}</SectionIntro.Description>}
    </SectionIntro>
  )
}
